import chroma from 'chroma-js'
import { localStorer } from '../lib/localStorer-sidecar'
import { pubSub } from './pubSub-sidecar'
import { soundsGeneric } from './soundsGeneric-sidecar'
// import type { IGenOptions } from '../proto/mower/proc/tinyGeneral'
// import type { IMowerSettings } from '../proto/mower/mowerSettings'

interface IHSL {
  h: number
  s: number
  l: number
}

export interface ISettings {
  devMode: boolean
  freeBuildMode: boolean
  multiplayerName: string
  muteSound: boolean
  muteMusic: boolean
  muteAmbient: boolean
  skipStart: boolean
  disableShaderTransitions: boolean
  // Extended
  filename: string
  testRigNum: number
  shipHullColor: IHSL
  shipInternalColor: IHSL
  physicsShowDebug: boolean
  // spriteGenSettings?: IGenOptions
  // mowerSettings?: IMowerSettings
}

let settings: ISettings = {
  devMode: false,
  freeBuildMode: false,
  multiplayerName: 'NewPlayer',
  muteSound: false,
  muteMusic: false,
  muteAmbient: false,
  skipStart: false,
  disableShaderTransitions: false,
  filename: 'test',
  testRigNum: -1,
  shipHullColor: { h: 100, s: 50, l: 50 },
  shipInternalColor: { h: 100, s: 10, l: 90 },
  physicsShowDebug: false,
}

let _localStorageKey = ''
let _version = 0
export function create(localStorageKey: string, version: number) {
  _localStorageKey = localStorageKey
  _version = version
  load()
}

export function get() {
  return settings
}
export function update(updates: Partial<ISettings>, doSave = true) {
  // console.log('update settings', updates, settings)
  settings = Object.assign({}, settings, updates)
  if (doSave) {
    save()
  }
  // console.log('update settings', updates, settings)
  pubSub.emit('settings:update')
}
export function updateShipHullColor(updates: Partial<IHSL>, doSave = true) {
  let newColor = Object.assign({}, settings.shipHullColor, updates)
  update({ shipHullColor: newColor }, doSave)
}
export function updateShipInternalColor(updates: Partial<IHSL>, doSave = true) {
  let newColor = Object.assign({}, settings.shipInternalColor, updates)
  update({ shipInternalColor: newColor }, doSave)
}
function load() {
  let data = localStorer.load(_localStorageKey, _version)
  if (data) {
    update(data, false)
  }
  console.log('loaded settings', data)
}

function save() {
  localStorer.save(_localStorageKey, _version, get())
}

export function getShipHullColorTint() {
  let c = chroma(
    settings.shipHullColor.h,
    settings.shipHullColor.s / 100,
    settings.shipHullColor.l / 100,
    'hsl',
  )
  return c.num()
}
export function getShipInternalColorTint() {
  let c = chroma(
    settings.shipInternalColor.h,
    settings.shipInternalColor.s / 100,
    settings.shipInternalColor.l / 100,
    'hsl',
  )
  return c.num()
}

// export function toggl() {
//   update({ muteMusic: !get().muteMusic })
// }
